<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-default m-b-30">
        <div class="container">
          <div class="row">
            <div class="col-md-6 text-center mx-auto text-white p-b-30 spacer-image">
              <button @click="printMe" class="btn btn-outline-info">
                Print
              </button>
            </div>
          </div>
        </div>
      </div>
      <section class="">
        <div class="container">

          <div class="row col-md-12">
            <div class="col-md-8 mx-auto" id="printDiv" ref="printNow">
              <div class="aschma-card">

                <!-- Header -->
                <div class="aschma-card-header">
                  <img :src="`/adamawa_govt.png`" class="aschma-card-header-logo" />
                  <div class="aschma-card-header-title">
                    <h4>{{ agency.agency_name }}</h4>
                  </div>
                  <img :src="`https://claimify-api.hayokmedicare.ng/image/${agency.user_image}`"
                    class="aschma-card-header-seal"
                    onerror="this.onerror=null; this.src='/assets/img/zamfara.jpg'" />
                </div>

                <!-- Facility Bar (full width) -->
                <div class="aschma-facility-bar" v-if="client.provider">
                  {{ client.provider.agency_name }}
                </div>

                <!-- Body: spouse + others, side by side underneath the facility bar -->
                <div class="aschma-split" v-if="client.dependents && client.dependents.length">

                  <!-- Spouse (first dependent) -->
                  <div class="aschma-spouse-col">
                    <img :src="`${client.dependents[0].image_url}`" class="aschma-photo aschma-photo--lg"
                      onerror="this.onerror=null; this.src='/assets/img/placeholder.svg'" />
                    <div class="aschma-primary-details">
                      <p class="aschma-name">{{ client.dependents[0].full_name }}</p>
                      <p>{{ client.dependents[0].id_card_number }}</p>
                      <p>{{ client.dependents[0].dob }}</p>
                      <p class="aschma-relationship">{{ client.dependents[0].relationShipType }}</p>
                      <p>{{ client.dependents[0].gender }}</p>
                    </div>
                  </div>

                  <!-- The other dependents -->
                  <div class="aschma-children">
                    <div class="aschma-child" v-for="(dep, idx) in dependentsExceptFirst" :key="dep.id || idx">
                      <img :src="`${dep.image_url}`" class="aschma-photo aschma-photo--sm"
                        onerror="this.onerror=null; this.src='/assets/img/placeholder.svg'" />
                      <p class="aschma-name-sm">{{ dep.full_name }}</p>
                      <p>{{ dep.id_card_number }}</p>
                      <p>{{ dep.dob }}</p>
                      <p class="aschma-relationship">{{ dep.relationShipType }}</p>
                      <p>{{ dep.gender }}</p>
                    </div>
                  </div>
                </div>

                <!-- Principal Bar -->
                <div class="aschma-principal-bar">
                  <p class="aschma-principal-name">{{ client.user.full_name }}</p>
                  <p class="aschma-principal-id">{{ client.user.id_card_number }}</p>
                  <p class="aschma-principal-work" v-if="client.user.place_of_work">
                    {{ client.user.place_of_work }}
                  </p>
                </div>

                <!-- Footer -->
                <div class="aschma-footer-bar">
                  ASCHMA Dependant Card
                </div>

              </div>
            </div>
          </div>

          <div class="col-md-8 mx-auto my-4">
            <div class="card m-b-30 p-8">
              <div class="card-body">

                <div class="row col-md-12">
                  <div class="col-md-12 text-center h5">
                    <p class="mb-12">
                      This card is the property of the <b>ASCHMA</b>
                    </p>
                    <p class="my-2">
                      If found, please return to ASCHMA office
                    </p>
                    <p class="my-2">
                      Plot 111 Ibrahgim Atta Street Old GRA Yola, Adamawa State
                    </p>
                    <p class="my-2">OR Call our Toll free lines below</p>
                    <p class="my-2"> <b>08031231231</b> and <b>07080601019</b> </p>
                  </div>

                  <div class="col-md-6 mt-12">
                    <p class="mt-12">
                      .....................................
                    </p>
                    <p>
                      <b> Authorized Signature</b>
                    </p>
                  </div>

                  <div class="col-md-6 float-right text-right mt-3">
                    <qrcode-vue :value="`https://app.claimify.ng/verify-user/${$route.params.id}`" :size="100"
                      class="float-right" :level="'H'" render-as="svg"></qrcode-vue>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="vld-parent">
          <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin
  let agency = JSON.parse(localStorage.getItem("agency"));
  import moment from "moment";
  moment().format();
  import QRCodeVue from "qrcode.vue";

  export default {
    components: {
      Navbar,
      Loading,
      qrcodeVue: QRCodeVue,
    },
    data() {
      return {
        agency: agency,
        user: null,
        trx_image: false,
        auth_user: "",
        client: "",
        trx_doc: null,
        notes: "",
        dependents: "",
        medications: "",
        healthFacility: "",
        date_id_card_issued: moment().format("YYYY-MM-DD"),
        signature: "",
        enrolled_by: "",
        singleward: "",
        singlelga: "",
        edit: false,
        isLoading: false,
        fullPage: true,
        transactionID: "",
        agency_id: "",
        imagefile: "",
        image: "",
        paymentProofFile: "",
        paymentProofImage: "",
        output: "",


      };
    },
    computed: {
      dependentsExceptFirst() {
        return this.client && Array.isArray(this.client.dependents)
          ? this.client.dependents.slice(1)
          : [];
      },
    },

    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
        .then((response) => {
          this.client = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    methods: {
      async print() {
        const el = this.$refs.printNow;

        const options = {
          type: "dataURL",
        };
        this.output = await this.$html2canvas(el, options);
      },

      printMe() {
        let printContents = document.getElementById("printDiv").innerHTML;
        let originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
      },

    },
    created() {
    },
  };
</script>
<style scoped>
  .aschma-card {
    border: 1px solid #d1d5db;
    border-radius: 6px;
    overflow: hidden;
    background: #fff;
    font-family: Arial, Helvetica, sans-serif;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  }

  .aschma-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding: 14px 18px 10px;
  }

  .aschma-card-header-logo,
  .aschma-card-header-seal {
    width: 58px;
    height: 58px;
    object-fit: contain;
    flex-shrink: 0;
  }

  .aschma-card-header-title {
    flex: 1;
    text-align: center;
  }

  .aschma-card-header-title h4 {
    color: #047857;
    font-weight: 800;
    font-size: 1.6rem;
    line-height: 1.3;
    margin: 0;
  }

  .aschma-facility-bar {
    background: #065f46;
    color: #fff;
    font-weight: 700;
    font-size: .82rem;
    letter-spacing: .03em;
    text-transform: uppercase;
    text-align: center;
    padding: 7px 18px;
  }

  .aschma-split {
    display: flex;
    align-items: stretch;
    gap: 48px;
    min-height: 150px;
  }

  .aschma-spouse-col {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    gap: 8px;
    flex: 0 0 30%;
    max-width: 30%;
    padding: 18px;
  }

  .aschma-photo {
    object-fit: cover;
    border: 2px solid #059669;
    border-radius: 10px;
    background: #f1f5f9;
  }

  .aschma-photo--lg {
    width: 105px;
    height: 125px;
  }

  .aschma-photo--sm {
    width: 74px;
    height: 88px;
  }

  .aschma-primary-details p,
  .aschma-child p {
    margin: 0 0 3px;
    font-size: .82rem;
    color: #1f2937;
  }

  .aschma-name {
    font-weight: 700;
    font-size: .92rem;
  }

  .aschma-name-sm {
    font-weight: 700;
    font-size: .74rem;
  }

  .aschma-relationship {
    text-transform: uppercase;
    font-weight: 700;
    font-size: .72rem;
    color: #374151;
  }

  .aschma-children {
    display: grid;
    grid-template-columns: repeat(2, max-content);
    justify-content: start;
    row-gap: 18px;
    column-gap: 80px;
    flex: 1;
    padding: 18px;
  }

  .aschma-child {
    width: 100px;
    text-align: left;
  }

  .aschma-child .aschma-photo--sm {
    margin-bottom: 4px;
  }

  .aschma-child p {
    font-size: .68rem;
  }

  .aschma-principal-bar {
    background: #f6c343;
    padding: 9px 18px;
  }

  .aschma-principal-bar p {
    margin: 0;
    color: #1f2937;
  }

  .aschma-principal-name {
    font-weight: 800;
    font-size: .85rem;
  }

  .aschma-principal-id {
    font-weight: 700;
    font-size: .8rem;
  }

  .aschma-principal-work {
    text-transform: uppercase;
    font-size: .72rem;
    font-weight: 700;
  }

  .aschma-footer-bar {
    background: #059669;
    color: #fff;
    text-align: center;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: .04em;
    padding: 9px;
    font-size: .88rem;
  }
</style>
